import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';

import { SanitizedHTML } from '../utils/Helper';

const PostLinkSection = ({ title, link, direction, categories, align }) => {
    const isPrev = direction === 'prev';
    const icon = isPrev ? faArrowLeft : faArrowRight;
    const label = isPrev ? 'Previous Post' : 'Next Post';
    const justifyClass = align === 'start' ? 'align-items-start' : 'align-items-end';

    return (
        <Col lg={6} md={6} sm={12} className={`wow fadeInUp d-flex flex-column ${justifyClass}`}>
            <button type="button" className="p-0 d-flex align-items-center gap5 mb-2">
                {isPrev && <FontAwesomeIcon icon={icon} className="me-2" />}
                {label}
                {!isPrev && <FontAwesomeIcon icon={icon} className="ms-2" />}
            </button>
            <Link to={link}>
                <SanitizedHTML html={title} tag="span" />
            </Link>
            <div className="post-category mt-2">
                {categories.map(({ slug, term_id, name }) => (
                    <Link to={`/category/${slug}`} key={slug}>
                        {name}
                    </Link>
                ))}
            </div>
        </Col>
    );
};

PostLinkSection.propTypes = {
    title: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    direction: PropTypes.oneOf(['prev', 'next']).isRequired,
    categories: PropTypes.arrayOf(
        PropTypes.shape({
            term_id: PropTypes.number,
            slug: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
        })
    ).isRequired,
    align: PropTypes.oneOf(['start', 'end']).isRequired,
};

const NavLinks = ({ data }) => {
    const {
        prev_post_title,
        next_post_title,
        prev_post_link,
        next_post_link,
        prev_post_cats = [],
        next_post_cats = [],
    } = data;

    return (
        <div className="nav-links wow mb-4 mt-4 pt-4 pb-4 fadeInUp">
            <Container>
                <Row className="position-relative">
                    <PostLinkSection
                        title={prev_post_title}
                        link={`/blog/${prev_post_link}`}
                        direction="prev"
                        categories={prev_post_cats}
                        align="start"
                    />
                    <PostLinkSection
                        title={next_post_title}
                        link={`/blog/${next_post_link}`}
                        direction="next"
                        categories={next_post_cats}
                        align="end"
                    />
                </Row>
            </Container>
        </div>
    );
};

NavLinks.propTypes = {
    data: PropTypes.shape({
        prev_post_title: PropTypes.string.isRequired,
        next_post_title: PropTypes.string.isRequired,
        prev_post_link: PropTypes.string.isRequired,
        next_post_link: PropTypes.string.isRequired,
        categories: PropTypes.arrayOf(
            PropTypes.shape({
                term_id: PropTypes.number,
                slug: PropTypes.string.isRequired,
                name: PropTypes.string.isRequired,
            })
        ).isRequired,
    }).isRequired,
};

export default NavLinks;
